import { render, staticRenderFns } from "./CouponSelect.vue?vue&type=template&id=4a97f644&scoped=true&"
import script from "./CouponSelect.vue?vue&type=script&lang=js&"
export * from "./CouponSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a97f644",
  null
  
)

export default component.exports